<div class="page">
  <app-page-header page-title="settings.document.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <app-card-spinner [visible]="cardIsLoading" type="zero">
      </app-card-spinner>
      <mat-card-title>{{ 'settings.document.detail' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ "settings.document.editing" | translate }}</mat-card-subtitle>
      <mat-card-content>
        <div class="row">
          <div *ngIf="documentTemplate.length">

            <div 
              class="col-12 col-md-5 col-lg-4 drop-list"
              cdkDropList
              #documentList="cdkDropList"
              [cdkDropListData]="documentTemplate"
              [cdkDropListConnectedTo]="[documentList]"
              (cdkDropListDropped)="drop($event)">
              <div class="drop-box" *ngFor="let item of documentTemplate; let i = index;" cdkDrag>
                <button mat-stroked-button class="btn-block" (click)="onTitleClicked(item._id)">
                  <div class="text-wrapper">
                    {{ item.translation.it }}
                  </div>
                </button>
              </div>
              <div class="row w-100 mt-4">
                <div class="col-6 text-left">
                  <a mat-button (click)="onSaveDocumentTemplate()" mat-raised-button mat-default color="primary">
                    {{ 'common.cta.save' | translate }}
                  </a>
                </div> <!-- /.col -->
                <div class="col-6 text-right">
                  <a mat-button (click)="onAddDocumentTemplate()" mat-raised-button mat-default color="primary">
                    {{ 'common.cta.add' | translate }}
                  </a>
                </div> <!-- /.col -->
              </div> <!-- /.row -->
            </div>

          </div>
          <div class="col-12 col-md-7 col-lg-8" *ngIf="formFirstLevelIsVisible">
            <div class="mt-1"><strong>{{ currentItemTitle }}</strong></div>
            <div class="form-wrapper mt-1">
              <form [formGroup]="form">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
                </formly-form>
              </form>
              <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions"
                class="btn-elevate">
              </mat-spinner-button>
            </div>

            <div *ngIf="subDocumentTemplate.length">
              <hr />
              <div class="mt-5"><strong>{{ 'settings.document.secondLevel' | translate }}</strong></div>

              <!-- Move content (section) to another area -->
              <div class="mt-3" *ngIf="documentTemplate.length > 1">
                <div class="mb-1"><strong>{{ 'settings.document.move.title' | translate }}</strong></div>
                <form [formGroup]="moveContentForm" class="row">
                  <mat-form-field class="col-12 col-md-6">
                    <mat-label>{{ 'settings.document.move.sourceContent' | translate }}</mat-label>
                    <mat-select formControlName="contentId" required>
                      <mat-option *ngFor="let content of subDocumentTemplate" [value]="content._id">
                        {{ content.translation.it }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-12 col-md-6">
                    <mat-label>{{ 'settings.document.move.destArea' | translate }}</mat-label>
                    <mat-select formControlName="destAreaId" required>
                      <ng-container *ngFor="let area of documentTemplate">
                        <mat-option *ngIf="area._id !== subDocumentTemplateId" [value]="area._id">
                          {{ area.translation.it }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                </form>
                <div class="text-right">
                  <a mat-button (click)="onMoveContentSubmit()" mat-raised-button mat-default color="primary">
                    {{ 'settings.document.move.save' | translate }}
                  </a>
                </div>
              </div>

              <div
                class="col-12 col-md-5 col-lg-4 drop-list mt-1"
                cdkDropList
                #subDocumentList="cdkDropList"
                [cdkDropListData]="subDocumentTemplate"
                [cdkDropListConnectedTo]="[subDocumentList]"
                (cdkDropListDropped)="drop($event)">
                <div class="drop-box" *ngFor="let item of subDocumentTemplate; let i = index;" cdkDrag>
                  <button mat-stroked-button class="btn-block" (click)="onSubTitleClicked(item)">
                    <div class="text-wrapper">
                      {{ item.translation.it }}
                    </div>
                  </button>
                </div>
                <div class="row w-100 mt-4">
                  <div class="col-6 text-left">
                    <a mat-button (click)="onSaveSubDocumentTemplate()" mat-raised-button mat-default color="primary">
                      {{ 'common.cta.save' | translate }}
                    </a>
                  </div> <!-- /.col -->
                  <div class="col-6 text-right">
                    <a mat-button (click)="onAddSubDocumentTemplate()" mat-raised-button mat-default color="primary">
                      {{ 'common.cta.add' | translate }}
                    </a>
                  </div> <!-- /.col -->
                </div> <!-- /.row -->
              </div>
  
            </div>
            <div *ngIf="formFirstLevelIsVisible && subDocumentTemplate.length === 0">
              <hr />
              <div class="mt-5"><strong>{{ 'settings.document.secondLevel' | translate }}</strong></div>
              <div class="col-12 col-md-5 col-lg-4 drop-list mt-1">
                Fai click sul pulsante "Aggiungi" per creare un nuovo elemento di "{{ currentItemTitle }}"
                <div class="row w-100">
                  <div class="col-6 text-left">

                  </div> <!-- /.col -->
                  <div class="col-6 text-right">
                    <a mat-button (click)="onAddSubDocumentTemplate()" mat-raised-button mat-default color="primary">
                      {{ 'common.cta.add' | translate }}
                    </a>
                  </div> <!-- /.col -->
                </div> <!-- /.row -->
              </div>
            </div>

            <!-- New sub element form -->
            <div *ngIf="formNewSubElementIsVisible">
              <div class="mt-5"><strong>{{ 'settings.document.newSecondLevel' | translate }}</strong></div>
              <div class="col-12 form-wrapper mt-1">
                <form [formGroup]="form">
                  <formly-form [form]="formSubElement" [fields]="fieldsSubElement" [model]="modelSubElement" [options]="optionsSubElement">
                  </formly-form>
                </form>
                <mat-spinner-button (btnClick)="onNewSubElementFormSubmit(modelSubElement)" role="submit" [options]="formBtnOptions"
                  class="btn-elevate">
                </mat-spinner-button>
              </div>
            </div>
          </div>

          <!-- new form-->
          <div class="col-12 col-md-7 col-lg-8" *ngIf="formNewIsVisible">
            <div class="mt-1"><strong>Nuova area</strong></div>
            <div class="form-wrapper mt-1">
              <form [formGroup]="form">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
                </formly-form>
              </form>
              <mat-spinner-button (btnClick)="onNewFormSubmit(model)" role="submit" [options]="formBtnOptions"
                class="btn-elevate">
              </mat-spinner-button>
            </div>
          </div>

          

        </div>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->
